import { Application } from '@hotwired/stimulus';

// Both `application.js` and `trestle.js` entry points import this module.
// On admin pages BOTH bundles load, so a naive `Application.start()` here
// would create two Stimulus applications — each with its own MutationObserver
// and its own controller instances per DOM element. Click handlers would
// fire twice, and any non-idempotent action (e.g. the bulk-upload fetch)
// would race itself.
//
// Guard with `window.Stimulus` so the first bundle to load wins and the
// second is a no-op. All controllers register against the same instance.
const application = window.Stimulus || Application.start();

application.debug = false;
window.Stimulus = application;

export { application };
